import React, { Component } from 'react';

import  PanelLayout  from "../layout/panel-layout";
import {history} from '../../helpers/history';
import { thisExpression } from '@babel/types';
const win = window;
let viewer=null;


class CertReqReport extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = { 
            ReportFormsList:[],
            ReportSize:'A4',
            model:null,
            isbusy:false
          
        };
        this.handlebackClick=this.handlebackClick.bind(this);
        this.onChange=this.onChange.bind(this);
        this.saveReportPdf=this.saveReportPdf.bind(this);
        this.onReportSizeChange=this.onReportSizeChange.bind(this);
     
    }
    

    handlebackClick()
    {
        history.goBack();
    }
    saveReportPdf() {
  
      
        var result=window.confirm('آیا اطلاعات گواهی را تایید می نمایید؟');
        if(result==true)
        {
            const {ReportSize}=this.state;
            this.setState({
                isbusy:true
            });
            const pdfSettings = new window.Stimulsoft.Report.Export.StiPdfExportSettings();
            const pdfService = new window.Stimulsoft.Report.Export.StiPdfExportService();
            const stream = new window.Stimulsoft.System.IO.MemoryStream();
            
            const {ReportFormsList,model,value}=this.state;

            var form=ReportFormsList.find(x=>x.value==value);
            var report = new window.Stimulsoft.Report.StiReport();

            var data={};

            if(form!=null && form.moralform!=null)
            {
                data={CertReq:model,moralform:form.moralform };
                report.loadFile(`/reports/${form.moralform.CertificationType.ReportFile}${ReportSize}Original.mrt`);

            }else if(form!=null && form.legalform!=null)
            {
                data={CertReq:model,legalform:form.legalform };
                report.loadFile(`/reports/${form.legalform.CertificationType.ReportFile}${ReportSize}Original.mrt`);
            }
            report.regData("Data","Data",data);
       
      
            report.renderAsync(function () {
            pdfService.exportToAsync(function () {
                const pdfData = report.exportDocument(window.Stimulsoft.Report.StiExportFormat.Pdf);
                (Object).saveAs(pdfData, 'file.pdf', 'application/pdf');
                    },  report, stream, pdfSettings);
                    }, false);
            this.setState({
                isbusy:false
            }); 
            

            this.props.addcertificateprint(model && model.Id)
        }       
    }

    

    onChange(e) {
        this.setState({
          value: e.target.value
        })
    }
    onReportSizeChange(e)
    {
        this.setState({
            ReportSize: e.target.value
          })
    }

    componentDidMount() {
        var options = new window.Stimulsoft.Viewer.StiViewerOptions();
        options.toolbar.visible = false;
        viewer = new window.Stimulsoft.Viewer.StiViewer(options, 'StiViewer', false);
        window.Stimulsoft.Base.StiLicense.key = "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";

        
        console.log('Rendering the viewer to selected element');
        viewer.renderHtml('viewer');
    }

    componentWillReceiveProps(newProps)
    {
        const {model} =newProps;

        if(model!=null)
        {

            this.setState({
                model:model
            })

            // filling report list

            const {ReportFormsList}=this.state;
            let counter=0;

            model.CertificationLegalForms.map((item)=>{
                counter=counter+1;
                if(counter==1)
                {
                    this.setState({
                        value:item.Id
                    });
                }
                ReportFormsList.push({name:item.CertificationType.Title,value:item.Id,legalform: item,moralform:null})
                return;
            });

            var moralFormslist= model.CertificationMoralForms.map((item)=>{
                counter=counter+1;
                if(counter==1)
                {
                    this.setState({
                        value:item.Id
                    });
                }
                ReportFormsList.push({name:item.CertificationType.Title,value:item.Id,moralform: item,legalform:null})
                return;
            });

            this.setState({
                ReportFormsList:ReportFormsList     
            });

            console.log('ReportFormsList',ReportFormsList);

            console.log('sss',{ CertificationRequest:model});
            var report = new window.Stimulsoft.Report.StiReport();
            report.loadFile('/reports/AddictionReport.mrt');
            report.regData("Data","Data",{ CertReq:model});
            viewer.report = report;
            report.render();
            viewer.renderHtml('viewer');
        }
    }

    loadReport(id)
    {
        const {ReportFormsList,model,ReportSize}=this.state;
        var form=ReportFormsList.find(x=>x.value==id);
        var report = new window.Stimulsoft.Report.StiReport();

        var data={};

        if(form!=null && form.moralform!=null)
        {
            data={CertReq:model,moralform:form.moralform };
            report.loadFile(`/reports/${form.moralform.CertificationType.ReportFile}${ReportSize}.mrt`);

        }else if(form!=null && form.legalform!=null)
        {
            data={CertReq:model,legalform:form.legalform };
            report.loadFile(`/reports/${form.legalform.CertificationType.ReportFile}${ReportSize}.mrt`);
        }

        

        
        report.regData("Data","Data",data);
        if(viewer!=null)
        {
            viewer.report = report;
        }
        report.render();
       
    }

  
    render() { 
        const {model} = this.props;
        const {ReportFormsList,value,isbusy}=this.state;
        this.loadReport(value);
        
        return ( 

        <PanelLayout title={"چاپ گواهی"}>

           
            <div className="panel-body custom">
            <div className="panel panel-default">
                
                <div className="toolbox">

                    <button type="button"  className="btn btn-default btn-sm" onClick={this.handlebackClick} ><i className="fa fa-arrow-right"></i>   بازگشت
                    
                    </button>
                    &nbsp;&nbsp;
                    <button type="button" disabled={!(model && model.RequestState==9)}  className="btn btn-success btn-sm" onClick={this.saveReportPdf} ><i className="fa fa-print"></i>   چاپ
                    { isbusy &&
                         <i className="fa fa-spinner fa-spin"></i>
                     }
                    </button>
                    &nbsp;&nbsp;
                    <label>نوع فرم: </label>
                    &nbsp;
                    <select onChange={this.onChange} value={this.state.value} >
                        {ReportFormsList.map((item)=>{
                           
                           return item && <option value={item.value}>{item.name}</option>
                        })}

                    </select>
                    &nbsp;&nbsp;
                    <label>اندازه: </label>
                    &nbsp;
                    <select value={this.state.ReportSize} onChange={this.onReportSizeChange} >
                        <option value="A4">A4</option>
                        <option value="A5">A5</option>
                       
                    </select>

                   
                </div>
            </div>
                <div id="viewer" style={{direction:"ltr"}}>&nbsp;</div>
           
               
            </div>
        </PanelLayout>





        );
    }
}

 
export default CertReqReport;